import { isNotNullOrUndefined } from '../is-not-null-or-undefined';

/**
 * A helper to use type narrowing for `null` and `undefined` on an objects property
 *
 * @param val - The object
 * @param key - The property key
 * @returns Boolean
 */
export function isPropertyNotNullOrUndefined<
    T,
    Key extends keyof T,
    R extends T & {
        [key in Key]-?: Exclude<T[key], null | undefined>;
    },
>(val: T | null | undefined, key: Key): val is R {
    return isNotNullOrUndefined(val) && isNotNullOrUndefined(val[key]);
}
